module.exports = __webpack_public_path__ + "img/play.d7f38a64.png";